import { SongUb } from "../../gql/graphql";
import { PlaylistItemData } from "../../playlist/data/PlaylistItemData";
import { LookupSongFunction } from "../../common/LookupSongFunction";
import { imageUrlForHash } from "../../helper/UrlResolver";

type SlideContent =
  | { kind: "invalid" }
  | { kind: "textOnly" }
  | { kind: "songsheet"; src: string }
  | { kind: "lyrics"; song: SongUb };

//one page of a playlist item: a songsheet image, or the whole song in lyrics (beamer) mode
export type CarouselSlide = SlideContent & {
  item: PlaylistItemData;
  pageInItem: number;
  key: string;
};

export function buildCarouselSlides(
  items: readonly PlaylistItemData[],
  isBeamerModeActive: boolean,
  lookupSong: LookupSongFunction,
): CarouselSlide[] {
  return items.flatMap((item) =>
    slideContents(lookupSong(item.songEntryId), isBeamerModeActive).map(
      (content, pageInItem) => ({
        ...content,
        item,
        pageInItem,
        key: `${item.id}-${pageInItem}`,
      }),
    ),
  );
}

function slideContents(
  song: SongUb | undefined,
  isBeamerModeActive: boolean,
): SlideContent[] {
  if (song === undefined) return [{ kind: "invalid" }];
  if (isBeamerModeActive) return [{ kind: "lyrics", song }];
  if (song.imageHashes.length === 0) return [{ kind: "textOnly" }];
  return song.imageHashes.map((image) => ({
    kind: "songsheet",
    src: imageUrlForHash(song.bucket, song.id, image.hash),
  }));
}
